import { ExternalUserServiceIntegration } from '../../../../../models/User'
import React from 'react'
import { useDeleteUserIntegrationMutation } from '../../../../../store/user/user'
import { Modal } from '../../../../../components/Modal/Modal'
import { Col, Container, Row } from 'react-bootstrap'
import { PhoneNumber } from '../../../../../components/PhoneNumber/PhoneNumber'

interface DeletePhoneIntegrationModalProps {
  accountId: string
  userId: string
  integration: ExternalUserServiceIntegration
  show: boolean
  onHide: () => void
}

export const DeletePhoneIntegrationModal: React.FC<DeletePhoneIntegrationModalProps> = ({ accountId, userId, integration, show, onHide }) => {
  const [deleteUserIntegration, { isLoading: isDeletingIntegration }] = useDeleteUserIntegrationMutation()

  const removePhoneIntegration = () => {
    if (userId && integration.id) {
      deleteUserIntegration({ accountId, payload: { userId: userId, integrationId: integration.id } })
      onHide()
    }
  }

  const body = (
    <Container>
      <Row className='pb-5'>
        <Col>
          <h4 className='d-flex justify-content-center align-items-center'>Delete phone number</h4>
        </Col>
      </Row>
      <Row className='pb-4'>
        <Col className='p-0'>
          <div className='paragraph-medium d-flex justify-content-center align-items-center'>Are you sure you want to delete this phone number?</div>
        </Col>
      </Row>
      <Row>
        <Col className='p-3 d-flex justify-content-center align-items-center zocks-bg-color-gray-100 zocks-border-0.5'>
          <h6 className='p-2'>
            <PhoneNumber phoneNumber={integration.externalId} />
          </h6>
        </Col>
      </Row>
    </Container>
  )
  return (
    <Modal
      show={show}
      onHide={onHide}
      header={<></>}
      body={body}
      showFooterActions={true}
      onFooterPrimaryAction={removePhoneIntegration}
      footerPrimaryActionLoading={isDeletingIntegration}
      footerPrimaryActionTitle='Delete'
      footerPrimaryActionButtonVariant='danger'
    ></Modal>
  )
}
